import { defineMessages } from "react-intl";

export const MANUAL_AIR_MESSAGES = defineMessages({
  repNoBankingDataTitle: {
    id: "funding-application: manual air rep no banking data title",
    defaultMessage: "Connect your bank",
  },
  repNoBankingDataDescription: {
    id: "funding-application: manual air rep no banking data description",
    defaultMessage: "We can't see any banking data.",
  },
  repNoBankingDataPanelBody: {
    id: "funding-application: manual air rep no banking data panel body",
    defaultMessage:
      "We couldn't retrieve any banking data for your application. We need {requiredMonths} months of continuous banking data with no gaps longer than 14 days. Go to your Connections page to connect a bank account or upload statements.",
  },

  repTriageMarketingTitle: {
    id: "funding-application: manual air rep triage marketing title",
    defaultMessage: "Connect your marketing platforms",
  },
  repTriageMarketingDescription: {
    id: "funding-application: manual air rep triage marketing description",
    defaultMessage: "Your banking shows material spend on {platformNames}.",
  },
  repTriageMarketingPanelBody: {
    id: "funding-application: manual air rep triage marketing panel body",
    defaultMessage:
      "Your banking shows material spend on {platformNames}. Go to your connections page to connect these platforms so we can continue your review.",
  },

  manualReconnectTitle: {
    id: "funding-application: manual air reconnect title",
    defaultMessage: "Reconnect your {platformType}",
  },
  manualReconnectDescription: {
    id: "funding-application: manual air reconnect description",
    defaultMessage: "We can't see your latest {platformType} data.",
  },
  manualReconnectPanelBody: {
    id: "funding-application: manual air reconnect panel body",
    defaultMessage:
      "Your {platformType} connection has dropped, so we can't see your latest data. Go to your connections page to reconnect it.",
  },

  defaultManualAirTitle: {
    id: "funding-application: manual air default title",
    defaultMessage: "Additional information requested",
  },
  defaultManualAirDescription: {
    id: "funding-application: manual air default description",
    defaultMessage: "Additional information is required to continue your application.",
  },
  defaultManualAirPanelBody: {
    id: "funding-application: manual air default panel body",
    defaultMessage: "We need additional information to continue your review. Please check your email for details.",
  },
  defaultPlatformFallback: {
    id: "funding-application: manual air default platform fallback",
    defaultMessage: "platform",
  },

  seeDetailsCta: {
    id: "funding-application: manual air see details cta",
    defaultMessage: "See details",
  },
  manualAirTimeEstimate: {
    id: "funding-application: manual air time estimate",
    defaultMessage: "Avg. 1 min",
  },
});
